import { ReactNode, forwardRef, ForwardedRef } from 'react';
import './style.scss';

interface IContainerProps {
  children: ReactNode;
  fluid?: boolean;
  style?: React.CSSProperties;
  id?: string;
  className?: string;
  px?: number;
  py?: number;
}

const Container = forwardRef<HTMLDivElement, IContainerProps>(
  ({
    children,
    fluid,
    style,
    id,
    className = '',
    px = 0,
    py = 0,
  }: IContainerProps, ref: ForwardedRef<HTMLDivElement>) => (
    <div
      id={id}
      className={`container ${fluid ? 'container__fluid' : ''} ${className}`}
      style={{ ...style, paddingLeft: px, paddingRight: px }}
      ref={ref}
    >
      {children}
    </div>
  ),
);

export default Container;
